module.exports = __webpack_public_path__ + "img/accounts.8dbee884.png";